import React, { useEffect, useRef, useState } from "react";
import Col from "react-bootstrap/Col";
import Modal from "react-bootstrap/Modal";
import Row from "react-bootstrap/Row";

// Components
import { InputField } from "../../../Components/formElements/InputField";
// import FileUploadComponent from "../../../Components/formElements/FileUploadComponent";
// import FileViewerModal from "../../../../Components/FileViewer/FileViewerModal";
import toast from "react-hot-toast";

//Serivce
import ItemService from "../../../services/customer_appCommonService";
// import { TextAreaField } from "../../../Components/formElements/TextAreaField";
import { useDispatch, useSelector } from "react-redux";
// import ShowUploadImageV5 from "./ShowUploadImageV5";
import FailureModal from "../../../Components/Modal/supplier_app/FailureModal";
// import { ComboboxField } from "../../../Components/formElements/ComboboxField";
import { getMaterialList } from "../../../redux/feature/customer_app/customerSlice";
// import { validateRequired } from "../../../common/Validations";
// import DataTable from "react-data-table-component";
// import { MultiselectFieldMrErf } from "../../../Components/formElements/MultiselectFieldMrErf";
import FileViewerModalForHB from "../../../Components/FileViewer/FileViewerModalForHB";
// import FileUploadComponentForHB from "../../../Components/formElements/FileUploadComponentForHB";
// import { SearchField } from "../../../Components/formElements/SearchField";
// import CustomerConstants from "../../../common/CustomerConstants";

const MaterialModal = React.forwardRef((props, ref) => {
  // const message = {
  //   VALID_CUSTOMER_NAME: "Special characters or numbers are not allowed.",
  //   VALID_MAIL_ID: "Please enter a valid email address.",
  //   VALID_ALTERNATE_MAIL_ID: "Please enter a valid alternate email address.",
  //   VALID_CONTACT_NUMBER: "Please enter a valid contact number.",
  //   VALID_ALTERNATE_CONTACT_NUMBER:
  //     "Please enter a valid alternate contact number.",
  //   VALID_PURPOSE_JUSTIFICATION:
  //     "Please ensure the justification is under 500 characters.",
  //   VALID_POSTAL_CODE:
  //     "Enter a 6-character postal code with uppercase letters and numbers only",
  //   VALID_CONTACT_FIRST_NAME: "Special characters and numbers are not allowed",
  //   VALID_CONTACT_LAST_NAME: "Special characters and numbers are not allowed",
  //   EXIStS_MAIL_ID: "Email already exists",
  //   EXIStS_CONTACT_NUMBER: "Contact Number already exists",
  //   EXIStS_ALTERNATE_CONTACT_NUMBER: "Contact Number already exists",
  //   EXIStS_ALTERNATE_MAIL_ID: "Alternate Contact Number already exists",
  //   FILL_REQUIRED_FIELD: "Please fill the required field",
  //   ALTERNATE_MAIL_ID: "Email ID is same",
  //   ALTERNATE_CONTACT_NUMBER: "Contact number is same",
  // };

  let materialNr = useSelector(
    (state) => state?.customerV1?.material?.materialNr,
  );

  const dispatch = useDispatch();
  const initialFormInputsRef = useRef(null);
   // eslint-disable-next-line
  const [accessoriesCode, setaccessoriesCode] = useState();

  const [formInputs, setFormInputs] = useState({
  
  });

  const failureModalData = {
    title: "Warning",
    ErrorMsg: "",
  };

  // eslint-disable-next-line
  const [validation, setValidation] = useState({});

  // eslint-disable-next-line
  const [getErrorFields, setErrorFields] = useState([]);

  const [getShowFailureModal, setShowFailureModal] = useState();

  // eslint-disable-next-line
  const [disabled, setDisabled] = useState("");

  const [getShowFileViewModal, setShowFileViewModal] = useState(false);
   // eslint-disable-next-line
  const [getFileViewData, setFileViewData] = useState(null);
  // eslint-disable-next-line
  const [fileDeleted, setFileDeleted] = useState(false);

  const [isCardVisible1, setCardVisible1] = useState(true);

  const [materialMode, setMaterialMode] = useState(true);

  const [loading, setLoading] = useState(false);

  // eslint-disable-next-line
  const [getDropdownData, setDropdownData] = useState("");
   // eslint-disable-next-line
  const [getCompanyCode, setCompanyCode] = useState([]);



  useEffect(() => {
    if (props?.show === "CREATE") {
      setMaterialMode(false);
    } else if (props?.show === "EDIT") {
      setMaterialMode(false);
    } else if (props?.show === "DETAILS") {
      setMaterialMode(true);
    } else {
      setMaterialMode(true);
    }
  }, [props?.show]);


  const toggleCardVisibility1 = () => {
    setCardVisible1(!isCardVisible1);
  };

  const hideFailureModal = () => {
    setShowFailureModal(false);
  };

  useEffect(() => {
    if (props?.show === "CREATE") {
      setFormInputs({

      });
    }
  }, [props?.show]);

  useEffect(() => {
    const handleEscapeKey = (event) => {
      if (event.key === "Escape" || event.keyCode === 27) {
        props.onHide();
      }
    };
    document.addEventListener("keydown", handleEscapeKey);
    return () => {
      document.removeEventListener("keydown", handleEscapeKey);
    };
  }, [props]);

  const numberFields = [
    "salePrice",
    "rentPerDayPrice",
    "rent7DaysPrice",
    "rent15DaysPrice",
    "rent30DaysPrice",
    "purchaseQuantity",
    "unitPrice",
    "mrPrice",
    "taxCode",
    "cog",
    "securityAmt",
    "lockInPeriod",
  ];
   // eslint-disable-next-line
  const [data, setData] = useState([]);
  // eslint-disable-next-line
  const [getSelectedData, setSelectedData] = useState([]);
  const [hospital, setHospitalData] = useState([]);
   // eslint-disable-next-line
  const [totalRows, setTotalRows] = useState(0);
   // eslint-disable-next-line
  const [pagination, setPagination] = useState({
    page: 1,
    per_page: 10,
  });

  const onInputChange = ({ target: { name, value } }) => {
    const errors = {};
    setFormInputs((prev) => ({
      ...prev,
      [name]: numberFields.includes(name)
        ? value === ""
          ? ""
          : Number(value)
        : value,
    }));
    setValidation((prev) => ({
      ...prev,
      [name]: errors[name] || "",
    }));
  };

  useEffect(() => {
    if ((props?.show === "EDIT" || props?.show === "DETAILS") && materialNr) {
      setLoading(true); // start loading
      let obj = {
        queryName: "Get_MATERIAL_DETAIL",
        documentNumber: materialNr,
      };
      ItemService.generateCustomerQuery(obj)
        .then((res) => {
          if (res?.data?.length) {
            setFormInputs(res.data[0]);
          }
        })
        .catch(() => {
          toast.error("Failed to fetch material details!");
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [props?.show, materialNr]);

  const handleSubmit = async () => {
    // let requiredFields = [];
    // const anyFieldNotEmpty = Object.values(validation).some(
    //   (value) => value !== null && value !== "",
    // );
    // if (anyFieldNotEmpty) {
    //   requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
    //   setErrorFields(requiredFields);
    //   setShowFailureModal(true);
    //   return;
    // }
    // if (!validateRequired(formInputs.companyCode)) {
    //   requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
    //   setErrorFields(requiredFields);
    //   setShowFailureModal(true);
    //   setValidation((prev) => ({
    //     ...prev,
    //     companyCode: message.FILL_REQUIRED_FIELD,
    //   }));
    //   return;
    // }
    // if (!validateRequired(formInputs.materialCode)) {
    //   requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
    //   setErrorFields(requiredFields);
    //   setShowFailureModal(true);
    //   setValidation((prev) => ({
    //     ...prev,
    //     materialCode: message.FILL_REQUIRED_FIELD,
    //   }));
    //   return;
    // }
    // if (!validateRequired(formInputs.materialGroup)) {
    //   requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
    //   setErrorFields(requiredFields);
    //   setShowFailureModal(true);
    //   setValidation((prev) => ({
    //     ...prev,
    //     materialGroup: message.FILL_REQUIRED_FIELD,
    //   }));
    //   return;
    // }
    // if (!validateRequired(formInputs.materialSubCategory)) {
    //   requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
    //   setErrorFields(requiredFields);
    //   setShowFailureModal(true);
    //   setValidation((prev) => ({
    //     ...prev,
    //     materialSubCategory: message.FILL_REQUIRED_FIELD,
    //   }));
    //   return;
    // }
    // if (!validateRequired(formInputs.materialDescription)) {
    //   requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
    //   setErrorFields(requiredFields);
    //   setShowFailureModal(true);
    //   setValidation((prev) => ({
    //     ...prev,
    //     materialDescription: message.FILL_REQUIRED_FIELD,
    //   }));
    //   return;
    // }
    // if (!validateRequired(formInputs.hsnCode)) {
    //   requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
    //   setErrorFields(requiredFields);
    //   setShowFailureModal(true);
    //   setValidation((prev) => ({
    //     ...prev,
    //     hsnCode: message.FILL_REQUIRED_FIELD,
    //   }));
    //   return;
    // }
    // if (!validateRequired(formInputs.purchaseQuantity)) {
    //   requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
    //   setErrorFields(requiredFields);
    //   setShowFailureModal(true);
    //   setValidation((prev) => ({
    //     ...prev,
    //     purchaseQuantity: message.FILL_REQUIRED_FIELD,
    //   }));
    //   return;
    // }
    // if (!validateRequired(formInputs.purchaseQuantity)) {
    //   requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
    //   setErrorFields(requiredFields);
    //   setShowFailureModal(true);
    //   setValidation((prev) => ({
    //     ...prev,
    //     purchaseQuantity: message.FILL_REQUIRED_FIELD,
    //   }));
    //   return;
    // }
    // if (!validateRequired(formInputs.unit)) {
    //   requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
    //   setErrorFields(requiredFields);
    //   setShowFailureModal(true);
    //   setValidation((prev) => ({
    //     ...prev,
    //     unit: message.FILL_REQUIRED_FIELD,
    //   }));
    //   return;
    // }
    // if (!validateRequired(formInputs.unitPrice)) {
    //   requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
    //   setErrorFields(requiredFields);
    //   setShowFailureModal(true);
    //   setValidation((prev) => ({
    //     ...prev,
    //     unitPrice: message.FILL_REQUIRED_FIELD,
    //   }));
    //   return;
    // }
    // if (!validateRequired(formInputs.mrPrice)) {
    //   requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
    //   setErrorFields(requiredFields);
    //   setShowFailureModal(true);
    //   setValidation((prev) => ({
    //     ...prev,
    //     mrPrice: message.FILL_REQUIRED_FIELD,
    //   }));
    //   return;
    // }
    // if (!validateRequired(formInputs.taxCode)) {
    //   requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
    //   setErrorFields(requiredFields);
    //   setShowFailureModal(true);
    //   setValidation((prev) => ({
    //     ...prev,
    //     taxCode: message.FILL_REQUIRED_FIELD,
    //   }));
    //   return;
    // }
    // if (!validateRequired(formInputs.cog)) {
    //   requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
    //   setErrorFields(requiredFields);
    //   setShowFailureModal(true);
    //   setValidation((prev) => ({
    //     ...prev,
    //     cog: message.FILL_REQUIRED_FIELD,
    //   }));
    //   return;
    // }
    // if (!validateRequired(formInputs.salePrice)) {
    //   requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
    //   setErrorFields(requiredFields);
    //   setShowFailureModal(true);
    //   setValidation((prev) => ({
    //     ...prev,
    //     salePrice: message.FILL_REQUIRED_FIELD,
    //   }));
    //   return;
    // }
    // if (!validateRequired(formInputs.rentPerDayPrice)) {
    //   requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
    //   setErrorFields(requiredFields);
    //   setShowFailureModal(true);
    //   setValidation((prev) => ({
    //     ...prev,
    //     rentPerDayPrice: message.FILL_REQUIRED_FIELD,
    //   }));
    //   return;
    // }
    // if (!validateRequired(formInputs.rent7DaysPrice)) {
    //   requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
    //   setErrorFields(requiredFields);
    //   setShowFailureModal(true);
    //   setValidation((prev) => ({
    //     ...prev,
    //     rent7DaysPrice: message.FILL_REQUIRED_FIELD,
    //   }));
    //   return;
    // }
    // if (!validateRequired(formInputs.rent15DaysPrice)) {
    //   requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
    //   setErrorFields(requiredFields);
    //   setShowFailureModal(true);
    //   setValidation((prev) => ({
    //     ...prev,
    //     rent15DaysPrice: message.FILL_REQUIRED_FIELD,
    //   }));
    //   return;
    // }
    // if (!validateRequired(formInputs.rent30DaysPrice)) {
    //   requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
    //   setErrorFields(requiredFields);
    //   setShowFailureModal(true);
    //   setValidation((prev) => ({
    //     ...prev,
    //     rent30DaysPrice: message.FILL_REQUIRED_FIELD,
    //   }));
    //   return;
    // }


   
    // Map material master fields to PO item keys
    const purchaseQty = Number(formInputs?.purchaseQuantity) || 0;
    const unitPrice = Number(formInputs?.orderPriceUnit) || 0;
    const taxPercent = Number(formInputs?.taxCode) || 0;
    const netValue = purchaseQty * unitPrice;
    const taxAmount = (taxPercent / 100) * netValue;

    const mappedData = {
      ...formInputs,
      materialCode: formInputs?.itemCode || formInputs?.materialCode || "",
      materialDescription: formInputs?.itemName || formInputs?.materialDescription || "",
      materialGroup: formInputs?.category || formInputs?.materialGroup || "",
      currency: "INR-Rupee",
      currencyCode: "INR",
      statusItem: "In Release",
      netValue: netValue,
      taxAmount: taxAmount,
      materialType:"MAT",
      materialCollection: "Supplier"
    };

    let obj = {
      data: mappedData,
    };

    setDisabled(true);
    await ItemService.addMaterial(obj).then((item) => {
      if (item?.status === 200) {
        toast.success(item?.message || "Material Added successfully", {
          duration: 2000,
          position: "top-right",
        });
        props.onHide();

        setFormInputs({

        });

        let obj = {
          queryName: "getMaterilMasterList",
          page: 1,
          per_page: 10,
        };
        dispatch(getMaterialList(obj));
      } else {
        toast.error(item?.message || "Please try again !!", {
          duration: 4000,
          position: "top-right",
        });
        // setErrorMsg("*" + item?.message);
      }
      setDisabled(false);
    });
    toast.dismiss("");
  };



  

  const handleUpdate = async () => {


    const { _id, ...rest } = formInputs;

    // Build dirty-only payload by comparing against the initial snapshot
    const initial = initialFormInputsRef.current || {};
    const changedFields = Object.keys(rest).reduce((acc, key) => {
      const curr = rest[key];
      const orig = initial[key];
      const isChanged =
        JSON.stringify(curr ?? "") !== JSON.stringify(orig ?? "");
      if (isChanged) acc[key] = curr;
      return acc;
    }, {});

    if (
      Object.keys(changedFields).length === 0 &&
      JSON.stringify(hospital) === JSON.stringify(initial.hospital || [])
    ) {
      toast("No changes to save.", { duration: 2000, position: "top-right" });
      return;
    }

    const cleanAccessories = (formInputs?.accessoriesCode || []).map((a) => ({
      materialCode: a.materialCode,
      materialDescription: a.materialDescription,
    }));

    const cleanHospital = hospital.flat().map((h) => ({
      _id: h._id,
      hospitalName: h.hospitalName || h.organisationName,
      hosptalCode: h.hosptalCode || h.customerCode,
      customerCode: h.customerCode,
      rentPerDayPrice: Number(h.rentPerDayPrice ?? 0),
      rent7DaysPrice: Number(h.rent7DaysPrice ?? 0),
      rent15DaysPrice: Number(h.rent15DaysPrice ?? 0),
      rent30DaysPrice: Number(h.rent30DaysPrice ?? 0),
      unitPrice: Number(h.unitPrice ?? 0),
      mrPrice: Number(h.mrPrice ?? 0),
      taxCode: Number(h.taxCode ?? 0),
      cog: Number(h.cog ?? 0),
      salePrice: Number(h.salePrice ?? 0),
    }));

    // Map material master fields to PO item keys
    const purchaseQty = Number(formInputs?.purchaseQuantity) || 0;
    const unitPrice = Number(formInputs?.orderPriceUnit) || 0;
    const taxPercent = Number(formInputs?.taxCode) || 0;
    const netValue = purchaseQty * unitPrice;
    const taxAmount = (taxPercent / 100) * netValue;

    const mappedFields = {
      materialCode: formInputs?.itemCode || formInputs?.materialCode || "",
      materialDescription: formInputs?.itemName || formInputs?.materialDescription || "",
      materialGroup: formInputs?.category || formInputs?.materialGroup || "",
      currency: "INR-Rupee",
      currencyCode: "INR",
      statusItem: "In Release",
      netValue: netValue,
      taxAmount: taxAmount,
    };

    // Create complete object by spreading formInputs and adding computed fields
    const completeObject = {
      ...formInputs, // This includes ALL form fields
      ...mappedFields,
      accessoriesCode: cleanAccessories,
      hospital: cleanHospital,
      timeZone: "Asia/Calcutta",
    };

    // Remove _id if it exists
    delete completeObject._id;

    // Create the final object
    const obj = {
      ...changedFields, // Only changed fields for main update (optional)
      ...mappedFields,
      accessoriesCode: cleanAccessories,
      hospital: cleanHospital,
      timeZone: "Asia/Calcutta",
      barcodeDetails: { ...completeObject }, // Complete object with ALL fields
    };

    setDisabled(true);
    await ItemService.updateMaterial(obj).then((item) => {
      if (item?.status === 200) {
        toast.success(item?.message || "Updated successfully", {
          duration: 2000,
          position: "top-right",
        });
        props.onHide();
        setFormInputs({
          materialAttachments: "",
          materialImage: "",
          materialCode: "",
          materialDescription: "",
          materialGroup: "",
          average: "",
          quntity: "",
          pieceMeasure: "",
          unit: "",
          unitWeight: "",
          unitPrice: "",
          unitWeightModifier: "",
          unitPriceModifier: "",
          surfacePaintArea: "",
          remarks: "",
          weightPice: "",
          weightTotal: "",
          bookPrice: "",
          bookTotalPrice: "",
          accessories: false,
          accessoriesCode: [],
        });
        initialFormInputsRef.current = null;
        let obj = {
          queryName: "getMaterilMasterList",
          page: 1,
          per_page: 10,
        };
        dispatch(getMaterialList(obj));
      } else {
        toast.error(item?.message || "Please try again !!", {
          duration: 4000,
          position: "top-right",
        });
      }
      setDisabled(false);
    });
    // toast.dismiss("");
  };

  const handleViewFileHide = () => {
    setShowFileViewModal(false);
  };

  useEffect(() => {
    if (getDropdownData?.textField === "materialGroup") {
      setFormInputs((formInputs) => ({
        ...formInputs,
        materialGroup: getDropdownData?.name,
        materialGroupCode: getDropdownData?.code,
        materialGroupDesc: getDropdownData?.description,
      }));
    } else if (getDropdownData?.textField === "unit") {
      setFormInputs((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.name,
        [getDropdownData?.textCode]: getDropdownData?.textCode,
        [getDropdownData?.textDesc]: getDropdownData?.textDesc,
      }));
    } else if (getDropdownData?.textField === "type") {
      setFormInputs((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.name,
        [getDropdownData?.textCode]: getDropdownData?.textCode,
        [getDropdownData?.textDesc]: getDropdownData?.textDesc,
      }));
    } else if (getDropdownData?.textField === "storageLocation") {
      setFormInputs((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.name,
        [getDropdownData?.textCode]: getDropdownData?.textCode,
        [getDropdownData?.textDesc]: getDropdownData?.textDesc,
      }));
    } else if (getDropdownData?.textField === "companyCode") {
      setFormInputs((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.companyCode,
        [getDropdownData?.textCode]: getDropdownData?.companyCodeCode,
        [getDropdownData?.textDesc]: getDropdownData?.companyCodeDesc,
      }));
    } else if (getDropdownData?.textField === "category") {
      setFormInputs((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.name,
      }));
    } else if (getDropdownData?.textField === "category") {
      setFormInputs((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.name,
      }));
    } else if (getDropdownData?.textField === "subCategory") {
      setFormInputs((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.name,
      }));
    } else if (getDropdownData?.textField === "targetCategory") {
      setFormInputs((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.name,
      }));
    } else if (getDropdownData?.textField === "materialSubCategory") {
      setFormInputs((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.name,
      }));
    } else if (getDropdownData?.textField === "criticalProduct") {
      setFormInputs((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.name,
      }));
    } else if (getDropdownData?.textField === "brand") {
      setFormInputs((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.name,
      }));
    } else if (getDropdownData?.textField === "discarded") {
      setFormInputs((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.name,
      }));
    } else if (getDropdownData?.textField === "topSelling") {
      setFormInputs((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.name,
      }));
    } else if (getDropdownData?.textField === "type") {
      setFormInputs((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.name,
      }));
    } else if (getDropdownData?.textField === "importedBy") {
      setFormInputs((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.name,
      }));
    } else if (getDropdownData?.textField === "mfgBy") {
      setFormInputs((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.name,
      }));
    } else if (getDropdownData?.textField === "mktBy") {
      setFormInputs((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.name,
      }));
    } else if (getDropdownData?.textField === "mrpStatus") {
      setFormInputs((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.name,
      }));
    }
    setValidation((prev) => ({
      ...prev,
      [getDropdownData?.textField]: "",
    }));
  }, [getDropdownData]);

  // AFTER
  useEffect(() => {
    if (props?.data) {
      // Normalize saved accessoriesCode: keep only entries that exist in master list
      const savedCodes = props.data?.accessoriesCode || [];
      const normalizedCodes = savedCodes
        .map((saved) => {
          const code = typeof saved === "string" ? saved : saved?.materialCode;
          return accessoriesCode?.find((item) => item.materialCode === code);
        })
        .filter(Boolean);

      const merged = {
        ...props.data,
        purchaseQuantity: props.data?.purchaseQuantity ?? 1,
        accessories: props.data?.accessories || false,
        accessoriesCode: normalizedCodes,
        // Ensure PO item keys are populated from material master fields
        materialCode: props.data?.itemCode || props.data?.materialCode || "",
        materialDescription: props.data?.itemName || props.data?.materialDescription || "",
        materialGroup: props.data?.category || props.data?.materialGroup || "",
        currency: props.data?.currency || "INR-Rupee",
        currencyCode: props.data?.currencyCode || "INR",
        statusItem: props.data?.statusItem || "In Release",
        netValue: props.data?.netValue || 0,
        taxAmount: props.data?.taxAmount || 0,
      };

      setFormInputs((prev) => ({ ...prev, ...merged }));
      initialFormInputsRef.current = merged;
      setHospitalData(props?.data?.hospital || []);
    }
    // eslint-disable-next-line
  }, [props]);

  // Fetch data when pagination changes
  useEffect(() => {
    if (props?.show && pagination.page) {
      let obj = {
        queryName: "getSupplierList",
        module: "",
        page: pagination.page,
        per_page: pagination.per_page,
        timeZone: "Asia/Calcutta",
        rowFilter: {
          $and: [
            {
              "vendorCategory.vendorCategoryCode": "V04",
            },
          ],
        },
      };

      ItemService.generateQuery(obj).then((item) => {
        if (item?.status === 200) {
          setData(item?.data);
          setTotalRows(item?.total || item?.data?.length || 0);
        }
      });
    }
    // eslint-disable-next-line
  }, [pagination.page, pagination.per_page]);

 

  const handleAttachmentDeleted = ({
    attachmentId,
    hasFiles,
    remainingCount,
  }) => {
    //  If NO files remain, clear the supportingDoc field
    if (!hasFiles) {
      setFormInputs((prev) => ({
        ...prev,
        materialAttachments: "", // ← Clear the attachment ID
      }));
      setFileDeleted(true);
    } else {
      //  If files still exist, update with new count (optional)
      console.log("Files still exist, count:", remainingCount);
    }
  };
  return (
    <>
      <Modal
        {...props}
        aria-labelledby="contained-modal-title-vcenter"
        keyboard={false}
        size="xl"
        ref={ref}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            {props?.show === "CREATE"
              ? "Create Material/Product"
              : props?.show === "DETAILS"
                ? "Material/Product Detail"
                : props?.show === "EDIT"
                  ? "Edit Material/Product"
                  : ""}{" "}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="">
          {loading ? (
            <div
              className="d-flex justify-content-center align-items-center"
              style={{ minHeight: "200px" }}
            >
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          ) : (
            <>
              {/* accordin1 */}
              <div
                xs={12}
                md={6}
                lg={6}
                className="commLeftRightPadding d-flex align-items-end mb-4"
              >
                {/* {props?.show !== "DETAILS" && (
                  <Col xs={12} md={4} lg={4} className="commLeftRightPadding">
                    <FileUploadComponent
                      id="materialImage"
                      name="materialImage"
                      label="Material Image"
                      allowedTypes={["image/png", "image/jpeg"]} // ✅ only images
                      multiple={false} // ✅ only single file selection
                      required={true}
                      onSuccessUpload={onSuccessUploadDocumentType}
                      value={formInputs?.materialImage || ""}
                    />
                  </Col>
                )} */}
                <Col
                  xs={12}
                  md={4}
                  lg={4}
                  className="commLeftRightPadding d-flex justify-content-center align-items-center"
                >
                  <div
                    style={{ width: "100%" }}
                    className="d-flex justify-content-center align-items-center"
                  >
                    {/* {formInputs?.materialImage && (
                      <img
                        src="assets/img/newIcons/attached-file.png"
                        className="mt-1 attachmentIcon"
                        alt="attachments"
                        onClick={() =>
                          handleViewFile(formInputs?.materialImage)
                        }
                      />
                    )} */}
                    {/* <ShowUploadImageV5 fileid={formInputs?.materialImage} /> */}
                  </div>
                </Col>
              </div>
              <div className="accordion mb-4" id="accordionExample">
                <div className="accordion-item">
                  <h2 className="accordion-header">
                    <Row className="accordion-button">
                      <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                        <i
                          className={`bi ${
                            isCardVisible1
                              ? "bi-chevron-down"
                              : "bi-chevron-right"
                          }`}
                          onClick={toggleCardVisibility1}
                        ></i>
                      </Col>
                      <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                        <span className="iconLogo">MI</span>
                      </Col>
                      <Col xs={8} md={9} lg={9}>
                        <span className="headerTitle">Material Information</span>
                        <span className="subHeaderTitle">
                          Material Information
                        </span>
                      </Col>
                    </Row>
                  </h2>

                  <div
                    className={`accordion-collapse collapse show ${
                      isCardVisible1 ? "visible" : ""
                    }`}
                  >
                    <div className="accordion-body">
                      <Row className="pt-2 pb-4 d-flex align-items-center">
                    
                          {/* <Col
                            xs={12}
                            md={6}
                            lg={6}
                            className="commTopButtonRightLeftPadding"
                          >
                            <ComboboxField
                              label="Company Code"
                              extraLabel="Company Code"
                              placeholder=""
                              data={getCompanyCode}
                              id="companyCode"
                              iconClassName="dropdownIcon"
                              name="companyCode"
                              code="companyCodeCode"
                              description="companyCodeDesc"
                              setValue={formInputs?.companyCode || ""}
                              getvalue={setDropdownData}
                              error={validation.companyCode}
                              required={true}
                              disabled={materialMode}
                            />
                          </Col> */}
                          <Col
                            xs={12}
                            md={6}
                            lg={6}
                            className="commLeftRightPadding"
                          >
                            <InputField
                              placeholder=""
                              className="inputBox"
                              label="Item Code"
                              id="itemCode"
                              name="itemCode"
                              type="text"
                              value={formInputs?.itemCode || ""}
                              onChange={onInputChange}
                              disabled={materialMode}
                              error={validation?.itemCode}
                              required={true}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={6}
                            lg={6}
                            className="commLeftRightPadding"
                          >
                            <InputField
                              placeholder=""
                              className="inputBox"
                              label="Item Name"
                              id="itemName"
                              name="itemName"
                              type="text"
                              value={formInputs?.itemName || ""}
                              onChange={onInputChange}
                              disabled={materialMode}
                              error={validation?.itemName}
                              required={true}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={6}
                            lg={6}
                            className="commLeftRightPadding"
                          >
                            <InputField
                              placeholder=""
                              className="inputBox"
                              label="Category"
                              id="category"
                              name="category"
                              type="text"
                              value={formInputs?.category || ""}
                              onChange={onInputChange}
                              disabled={materialMode}
                              error={validation?.category}
                              required={true}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={6}
                            lg={6}
                            className="commLeftRightPadding"
                          >
                            <InputField
                              placeholder=""
                              className="inputBox"
                              label="Sub Category"
                              id="subCategory"
                              name="subCategory"
                              type="text"
                              value={formInputs?.subCategory || ""}
                              onChange={onInputChange}
                              disabled={materialMode}
                              error={validation?.subCategory}
                              required={true}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={6}
                            lg={6}
                            className="commLeftRightPadding"
                          >
                            <InputField
                              placeholder=""
                              className="inputBox"
                              label="Specification"
                              id="specification"
                              name="specification"
                              type="text"
                              value={formInputs?.specification || ""}
                              onChange={onInputChange}
                              disabled={materialMode}
                              error={validation?.specification}
                              required={true}
                            />
                          </Col>

                          <Col
                            xs={12}
                            md={6}
                            lg={6}
                            className="commLeftRightPadding"
                          >
                            <InputField
                              placeholder=""
                              className="inputBox"
                              label="Order Unit of Measure (UOM)"
                              id="orderUnitOfMeasure"
                              name="orderUnitOfMeasure"
                              type="text"
                              value={formInputs?.orderUnitOfMeasure || ""}
                              onChange={onInputChange}
                              disabled={materialMode}
                              error={validation?.orderUnitOfMeasure}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={6}
                            lg={6}
                            className="commLeftRightPadding"
                          >
                            <InputField
                              placeholder=""
                              className="inputBox"
                              label="Order Price Unit (Unit Price)"
                              id="orderPriceUnit"
                              name="orderPriceUnit"
                              type="number"
                              value={formInputs?.orderPriceUnit || ""}
                              onChange={onInputChange}
                              disabled={materialMode}
                              error={validation?.orderPriceUnit}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={6}
                            lg={6}
                            className="commLeftRightPadding"
                          >
                            <InputField
                              placeholder=""
                              className="inputBox"
                              label="Tax Code (%)"
                              id="taxCode"
                              name="taxCode"
                              type="number"
                              value={formInputs?.taxCode || ""}
                              onChange={onInputChange}
                              disabled={materialMode}
                              error={validation?.taxCode}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={6}
                            lg={6}
                            className="commLeftRightPadding"
                          >
                            <InputField
                              placeholder=""
                              className="inputBox"
                              label="Plant"
                              id="plant"
                              name="plant"
                              type="text"
                              value={formInputs?.plant || ""}
                              onChange={onInputChange}
                              disabled={materialMode}
                              error={validation?.plant}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={6}
                            lg={6}
                            className="commLeftRightPadding"
                          >
                            <InputField
                              placeholder=""
                              className="inputBox"
                              label="Storage Location"
                              id="storageLocn"
                              name="storageLocn"
                              type="text"
                              value={formInputs?.storageLocn || ""}
                              onChange={onInputChange}
                              disabled={materialMode}
                              error={validation?.storageLocn}
                            />
                          </Col>
                      </Row>
                    </div>
                  </div>
                </div>
              </div>
              {props.show !== "DETAILS" && (
                <div className="space-y-4">
                  <Row className="justify-end">
                    <Col xs={6} md={3} lg={3} className="commLeftRightPadding">
                      <button
                        type="button"
                        onClick={() => props.onHide()}
                        className="btn btn-danger mt-4 w-full justify-center rounded-md"
                      >
                        Cancel
                      </button>
                    </Col>
                    {props.show === "CREATE" && (
                      <Col
                        xs={6}
                        md={3}
                        lg={3}
                        className="commLeftRightPadding"
                      >
                        <button
                          onClick={handleSubmit}
                          disabled={materialMode}
                          className="btn btn-primary mt-4 w-full justify-center rounded-md"
                        >
                          Save
                        </button>
                      </Col>
                    )}
                    {props.show === "EDIT" && (
                      <Col
                        xs={6}
                        md={3}
                        lg={3}
                        className="commLeftRightPadding"
                      >
                        <button
                          onClick={handleUpdate}
                          // disabled={materialMode}
                          disabled={disabled}
                          className="btn btn-primary mt-4 w-full justify-center rounded-md"
                        >
                          Update
                        </button>
                      </Col>
                    )}
                    <Col
                      xs={12}
                      md={12}
                      lg={12}
                      className="commLeftRightPadding"
                    >
                      {/* <p className="errorMsg"> {errorMsg} </p> */}
                    </Col>
                  </Row>
                </div>
              )}
            </>
          )}
        </Modal.Body>
      </Modal>

      {/* <FileViewerModal
        show={getShowFileViewModal}
        onHide={handleViewFileHide}
        fileid={getFileViewData}
      /> */}
      <FileViewerModalForHB
        show={getShowFileViewModal}
        onHide={handleViewFileHide}
        fileid={getFileViewData}
        onDeleteSuccess={handleAttachmentDeleted}
      />
      <FailureModal
        show={getShowFailureModal}
        onHide={() => hideFailureModal()}
        failuremodaldata={failureModalData}
        requiredfields={getErrorFields}
      />
    </>
  );
});

export default MaterialModal;
